import { useState, useEffect } from "react";
import "../../../assets/css/staff.css";
import TableControls from "../../../components/TableControls";

const API_BASE =
  "http://localhost/GMT_TECHNOLOGIES_LIMITED_CLEAN/gmt-api/loans/loans.php?status=disbursed";

export default function Disbursements() {
  const [loanList, setLoanList] = useState([]);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedLoans = loanList.slice(startIndex, startIndex + rowsPerPage);

  useEffect(() => {
    fetchLoans();
  }, []);

  const fetchLoans = async () => {
    try {
      const res = await fetch(API_BASE);
      const data = await res.json();
      setLoanList(data);
      setCurrentPage(1);
    } catch (err) {
      console.error("Failed to fetch loans", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="staff-page">
      <div className="page-header">
        <div className="page-header-left">
          <h2 className="page-title">Disbursed Loans</h2>
          <p className="page-subtitle">Loans already paid out</p>
        </div>
      </div>

      <div className="card">
        <TableControls
          totalItems={loanList.length}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          onPageChange={setCurrentPage}
          onRowsPerPageChange={setRowsPerPage}
        />

        {loading ? (
          <p>Loading loans...</p>
        ) : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Applicant</th>
                  <th>Product</th>
                  <th>Amount</th>
                  <th>Tenor</th>
                  <th>Disbursed Date</th>
                </tr>
              </thead>

              <tbody>
                {paginatedLoans.map((loan) => (
                  <tr key={loan.id}>
                    <td>{loan.customer_name}</td>
                    <td>{loan.product_name}</td>
                    <td>₦{Number(loan.amount).toLocaleString()}</td>
                    <td>{loan.tenor} months</td>
                    <td>
                      {new Date(loan.disbursed_at).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
